export default "__VITE_ASSET__BjXnr3CO__"